import lodash from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Col, Icon } from 'antd';
import Moment from 'react-moment';
import Table from '../../../../../../components/table/Table';
import { SET_MODAL_WINDOW_DATA } from '../../../../../App/redux/constants/modalWindow.constants';
import AddNewPriceSuggestion from './AddNewPriceSuggestion';

const tableCols = [
    { content: 'Note', align: 'center' },
    { content: 'Created At', align: 'center' },
    { content: 'Created By', align: 'center' },
];

class ModelPriceSuggestions extends React.Component {
    handleClickOpenModal = () => {
        const { dispatch, modelId } = this.props;

        dispatch({
            type: SET_MODAL_WINDOW_DATA,
            payload: {
                isLoading: false,
                isOpen: true,
                maxWidth: 'md',
                content: {
                    header: 'New Price Suggestion',
                    body: <AddNewPriceSuggestion modelId={modelId} />,
                },
            },
            ignoreValueAsFn: true,
        });
    }

    render() {
        const { data } = this.props;
        const dataExists = lodash.isArray(data) && !lodash.isEmpty(data);

        return (
            !dataExists
                ? (
                    <Col span={24}>
                        <div className="profile__information existingStock" style={{ marginLeft: -15, width: '98%' }}>
                            <div className="profile__data valuation">
                                <h3>
                                    Price Suggestions
                                    <span key="addNew" className="select_manually" onClick={this.handleClickOpenModal}>
                                        <Icon type="edit" style={{ paddingRight: '5px' }} />
                                        Add New
                                    </span>
                                </h3>
                                <p style={{width:'100%', marginLeft:15}}>There are currently no suggestions around price for this bike</p>
                            </div>
                        </div>
                    </Col>
                )
                : (
                    <Col span={24}>
                        <div className="profile__information existingStock" style={{ marginLeft: -15, width: '98%' }}>
                            <div className="profile__data valuation">
                                <h3>
                                    Price Suggestions
                                    <span key="addNew" className="select_manually" onClick={this.handleClickOpenModal}>
                                        <Icon type="edit" style={{ paddingRight: '5px' }} />
                                        Add New
                                    </span>
                                </h3>
                                <div className="tableWrapper">
                                    <div className="profile__contact">
                                        <Table>
                                            <thead>
                                                <tr>
                                                    {
                                                        tableCols.map((item, idx) => <th key={idx} className="tableHeader">{item.content}</th>)
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    data.map((item) => {
                                                        const userName = `${lodash.get(item, 'created_by.person.first_name')} ${lodash.get(item, 'created_by.person.last_name')}`;

                                                        return (
                                                            <tr key={item._id}>
                                                                <td align={tableCols[0].align}>
                                                                    <span>{item.note}</span>
                                                                </td>
                                                                <td align={tableCols[1].align}>
                                                                    <span><Moment format="D MMM YYYY | HH:mm">{item.created_at}</Moment></span>
                                                                </td>
                                                                <td align={tableCols[2].align}>
                                                                    <span>{userName}</span>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                )
        );
    }
}

const mapStateToProps = (state) => {
    const { bike_details } = state.Leads.Lead_profile.Ref_bike_lead;
    const priceSuggestions = lodash.get(bike_details, 'ref_bike_model.price_suggestions');
    const modelId = lodash.get(bike_details, 'ref_bike_model._id');

    return {
        data: priceSuggestions,
        modelId,
    };
};

export default connect(mapStateToProps)(ModelPriceSuggestions);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/ModelPriceSuggestions/index.js